"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Image = require("../Image");

var _Spacer = require("../Spacer");

var _Typography = require("../Typography");

var _CardTag = require("./CardTag");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * `SmallCard` is a card with a layout one square image on the left,
 * one tall or two square images on the right, and text for title and subtitle
 * at the bottom.
 */
var SmallCard = function SmallCard(_ref) {
  var images = _ref.images,
      title = _ref.title,
      subtitle = _ref.subtitle,
      tag = _ref.tag;
  return _react.default.createElement(_Box.Box, {
    width: "100%",
    position: "relative"
  }, _react.default.createElement(_Box.Box, {
    width: "100%",
    height: "0",
    pt: "67%",
    position: "relative"
  }, _react.default.createElement(_Flex.Flex, {
    flexDirection: "row",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    borderRadius: "4px",
    overflow: "hidden"
  }, _react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    width: "67%",
    overflow: "hidden",
    mr: "1px"
  }, _react.default.createElement(_Image.Image, {
    src: images[0],
    alt: title,
    height: "100%",
    width: "auto"
  })), _react.default.createElement(_Flex.Flex, {
    width: "33%",
    flexDirection: "column"
  }, images.length < 2 && _react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    height: "100%",
    width: "100%",
    ml: "1px"
  }), !!images[1] && _react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    height: !!images[2] ? "50%" : "100%",
    overflow: "hidden",
    ml: "1px",
    mb: !!images[2] ? "1px" : "0"
  }, _react.default.createElement(_Image.Image, {
    src: images[1],
    alt: title,
    height: "100%",
    width: "auto"
  })), !!images[2] && _react.default.createElement(_Box.Box, {
    backgroundColor: "black10",
    height: "50%",
    overflow: "hidden",
    ml: "1px",
    mt: "1px"
  }, _react.default.createElement(_Image.Image, {
    src: images[2],
    alt: title,
    height: "100%",
    width: "auto"
  }))))), _react.default.createElement(_Spacer.Spacer, {
    mt: 1
  }), _react.default.createElement(_Typography.Sans, {
    size: "3t",
    weight: "medium"
  }, title), !!subtitle && _react.default.createElement(_Typography.Sans, {
    size: "3t",
    color: "black60"
  }, subtitle), !!tag && _react.default.createElement(_CardTag.CardTag, _extends({}, tag, {
    position: "absolute",
    top: 1,
    left: 1
  })));
};

exports.SmallCard = SmallCard;
SmallCard.displayName = "SmallCard";
//# sourceMappingURL=SmallCard.js.map